export default function MembersCtrl($scope) {
}